module.exports = __webpack_public_path__ + "static/media/pagingHome.451341b5.png";